<template>
	<div v-if="!props.isError && props.data.invest_score" class="wrap wrap_score">
		<section class="section_chart">
			<div style="width: 27.2rem"><canvas :id="chartId"></canvas></div>
		</section>
		<section class="section_description">
			<div class="content_chartDetail">
				<MoreButton title="지표별 설명 보기" @click="isDescriptionOpened = !isDescriptionOpened" />
				<div v-if="isDescriptionOpened" class="chartDetail_description">
					<ul class="description_list">
						<li class="list_box">
							<div class="box_row_1">
								<div class="row_1_left">
									<h3>안정성</h3>
									<p>
										{{ eventInvestmentIndicatorsValue[0] }}
									</p>
								</div>
								<div class="row_1_right" @mouseover="selectedTip = '안정성'" @mouseout="selectedTip = ''">
									<img src="@/assets/img/common/question.svg" alt="도움말" loading="lazy" />
									<div v-if="selectedTip === '안정성'" class="right_descriptionItem leftItem">
										<h4>안정성</h4>
										<ul>
											<li>
												<span>부채비율</span>
												<span>기업의 건전성지표</span>
											</li>
											<li>
												<span>{{ headerStore.getCountry === 'KR' ? '유보율' : '당좌비율' }}</span>
												<span>{{
													headerStore.getCountry === 'KR'
														? '기업의 유보 자산을 나타내는 지표'
														: '기업의 단기채무 상환능력 지표'
												}}</span>
											</li>
											<li>
												<span>유동비율</span>
												<span>유동자산을 유동부채로 나눈 비율</span>
											</li>
											<p>3가지 지표를 종합합산 산정</p>
										</ul>
									</div>
								</div>
							</div>
							<p class="box_row_2">{{ eventInvestmentIndicatorsDescription[0] }}</p>
						</li>
						<li class="list_box">
							<div class="box_row_1">
								<div class="row_1_left">
									<h3>수익성</h3>
									<p>
										{{ eventInvestmentIndicatorsValue[1] }}
									</p>
								</div>
								<div class="row_1_right" @mouseover="selectedTip = '수익성'" @mouseout="selectedTip = ''">
									<img src="@/assets/img/common/question.svg" alt="도움말" loading="lazy" />
									<div v-if="selectedTip === '수익성'" class="right_descriptionItem">
										<h4>수익성</h4>
										<ul>
											<li>
												<span>{{ headerStore.getCountry === 'KR' ? '매출총이익률' : '당기순이익률' }}</span>
												<span>{{
													headerStore.getCountry === 'KR'
														? '매출에서 원가를 뺀 이익의 비율'
														: '매출액에 대한 순이익 비율'
												}}</span>
											</li>
											<li>
												<span>영업이익률</span>
												<span>매출액에 대한 영업이익 비율</span>
											</li>
											<li>
												<span>자기자본이익률</span>
												<span>자기자본에 대한 기간이익 비율</span>
											</li>
											<p>3가지 지표를 종합합산 산정</p>
										</ul>
									</div>
								</div>
							</div>
							<p class="box_row_2">{{ eventInvestmentIndicatorsDescription[1] }}</p>
						</li>
						<li class="list_box">
							<div class="box_row_1">
								<div class="row_1_left">
									<h3>성장성</h3>
									<p>
										{{ eventInvestmentIndicatorsValue[2] }}
									</p>
								</div>
								<div class="row_1_right" @mouseover="selectedTip = '성장성'" @mouseout="selectedTip = ''">
									<img src="@/assets/img/common/question.svg" alt="도움말" loading="lazy" />
									<div v-if="selectedTip === '성장성'" class="right_descriptionItem leftItem">
										<h4>성장성</h4>
										<ul>
											<li>
												<span>매출액증가율</span>
												<span>매출액 증가 비율</span>
											</li>
											<li>
												<span>영업이익증가율</span>
												<span>영업이익 증가 비율</span>
											</li>
											<li>
												<span>순이익증가율</span>
												<span>당기순이익 증가 비율</span>
											</li>
										</ul>
										<p>3가지 지표를 종합합산 산정</p>
									</div>
								</div>
							</div>
							<p class="box_row_2">{{ eventInvestmentIndicatorsDescription[2] }}</p>
						</li>
						<li class="list_box">
							<div class="box_row_1">
								<div class="row_1_left">
									<h3>밸류</h3>
									<p>
										{{ eventInvestmentIndicatorsValue[3] }}
									</p>
								</div>
								<div class="row_1_right" @mouseover="selectedTip = '밸류'" @mouseout="selectedTip = ''">
									<img src="@/assets/img/common/question.svg" alt="도움말" loading="lazy" />
									<div v-if="selectedTip === '밸류'" class="right_descriptionItem">
										<h4>밸류</h4>
										<ul>
											<li>
												<span>주가순자산비율</span>
												<span>주가와 순자산 비교 비율</span>
											</li>
											<li>
												<span>주가수익비율</span>
												<span>주가 / 주당순이익</span>
											</li>
											<li>
												<span>{{ headerStore.getCountry !== 'JPN' ? 'PSR' : 'EV/EBITDA' }}</span>
												<span>{{
													headerStore.getCountry !== 'JPN' ? '시가총액 / 매출액' : '기업의 시장가치 / 세전 영업이익'
												}}</span>
											</li>
											<p>3가지 지표를 종합합산 산정</p>
										</ul>
									</div>
								</div>
							</div>
							<p class="box_row_2">{{ eventInvestmentIndicatorsDescription[3] }}</p>
						</li>
						<li class="list_box">
							<div class="box_row_1">
								<div class="row_1_left">
									<h3>배당</h3>
									<p>
										{{ eventInvestmentIndicatorsValue[4] }}
									</p>
								</div>
								<div class="row_1_right" @mouseover="selectedTip = '배당'" @mouseout="selectedTip = ''">
									<img src="@/assets/img/common/question.svg" alt="도움말" loading="lazy" />
									<div v-if="selectedTip === '배당'" class="right_descriptionItem leftItem">
										<h4>배당</h4>
										<ul>
											<li>
												<span>배당수익률</span>
												<span>주가대비 배당금 비율</span>
											</li>
											<li>
												<span>배당기간</span>
												<span>배당의 지속성 체크</span>
											</li>
											<li>
												<span>배당여력</span>
												<span>이익증가에 따른 배당여력 측정</span>
											</li>
											<p>3가지 지표를 종합합산 산정</p>
										</ul>
									</div>
								</div>
							</div>
							<p class="box_row_2">{{ eventInvestmentIndicatorsDescription[4] }}</p>
						</li>
					</ul>
				</div>
			</div>
			<div
				v-if="
					!(props.data.invest_score.detail_description === '<p></p>' || !props.data.invest_score.detail_description)
				"
				v-dompurify-html="props.data.invest_score.detail_description"
				class="c_editorContent c_editorContent_outline"
				:class="props.data.invest_score.detail_description === '<p></p>' && 'emptyData'"
			></div>
		</section>
	</div>

	<div v-else class="only_picked">
		<p>{{ ONLY_PICKED }}</p>
	</div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import Chart from 'chart.js/auto';

import { GetInvestReportScoreRes } from '@/api/report';
import MoreButton from '@/components/atom/button/MoreButton.vue';
import { ONLY_PICKED } from '@/constants/title';
import { useHeaderStore } from '@/stores/header';

// -----variable-----
const props = defineProps<{
	data: GetInvestReportScoreRes;
	isError?: boolean;
}>();

const headerStore = useHeaderStore();
const chartId = ref('chart-' + Math.random().toString(36).substring(2, 9));
const selectedTip = ref('');
const isDescriptionOpened = ref(false);
const eventInvestmentIndicatorsLabel = ref<string[]>([]);
const eventInvestmentIndicatorsValue = ref<number[]>([]);
const eventInvestmentIndicatorsDescription = ref<string[]>([]);

// -----function-----
const createChart = () => {
	const ctx = document.getElementById(chartId.value) as HTMLCanvasElement;

	if (ctx) {
		new Chart(ctx, {
			type: 'radar',
			data: {
				labels: eventInvestmentIndicatorsLabel.value,
				datasets: [
					{
						data: eventInvestmentIndicatorsValue.value,
						fill: true,
						backgroundColor: 'rgba(0, 0, 0, 0)',
						borderColor: '#FF5E00',
						borderWidth: 2,
						pointBackgroundColor: '#fff',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: 'rgb(255, 99, 132)',
					},
				],
			},
			options: {
				layout: {
					padding: {
						top: 40,
						right: 40,
						bottom: 40,
						left: 40,
					},
				},
				scales: {
					r: {
						min: 0,
						max: 100,
						ticks: {
							stepSize: 50,
							maxTicksLimit: 100,
							display: false,
						},
						beginAtZero: true,
						grid: {
							color: '#393D45',
						},
						angleLines: {
							color: '#393D45',
							borderDash: [2, 3],
						},
						pointLabels: {
							display: false,
							color: '#FFFFFF',
							font: {
								size: 15,
								weight: '400',
							},
							callback: function (value: string) {
								if (value.includes(' ')) {
									return value.split(' ');
								}
								return value;
							},
						},
					},
				},
				plugins: {
					legend: {
						display: false,
					},
				},
				elements: {
					line: {
						borderWidth: 3,
					},
					point: {
						radius: 0,
					},
				},
			},
			// textAlign, fontWeight 조절을 위해 기존 라벨 삭제 후 커스텀
			plugins: [
				{
					id: 'customLabel',
					afterDraw: (chart) => {
						const ctx = chart.ctx;
						const meta = chart.getDatasetMeta(0);

						const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
						const centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;

						// 레이더 차트의 최대 반지름 계산
						const radius = Math.min(
							(chart.chartArea.right - chart.chartArea.left) / 2,
							(chart.chartArea.bottom - chart.chartArea.top) / 2
						);

						meta.data.forEach((_point, index) => {
							const value = eventInvestmentIndicatorsLabel.value[index];
							let data1, data2;

							if (value.includes(' ')) {
								[data1, data2] = value.split(' ');
							} else {
								data1 = value;
								data2 = '데이터 없음';
							}

							// 각도 계산 (라벨의 개수에 따라 균등하게 분배)
							const angle = index * ((2 * Math.PI) / meta.data.length) - Math.PI / 2;

							// 최대 반지름을 기준으로 x, y 좌표 계산
							const x = centerX + radius * Math.cos(angle);
							const y = centerY + radius * Math.sin(angle);
							const textRadius = 25;

							ctx.save();
							ctx.textAlign = 'center';
							ctx.fillStyle = '#FFFFFF';
							ctx.font = '15px Arial';

							ctx.fillText(data1, x + textRadius * Math.cos(angle), y + textRadius * Math.sin(angle));
							if (data2) {
								ctx.font = 'bold 15px Arial';
								ctx.fillText(data2, x + textRadius * Math.cos(angle), y + textRadius * Math.sin(angle) + 20);
							}

							ctx.restore();
						});
					},
				},
			],
		});
	}
};

// -----composition-----
onMounted(async () => {
	// section_indicator 차트
	eventInvestmentIndicatorsLabel.value = [
		`안정성 ${props.data.invest_score.stability_score}`,
		`수익성 ${props.data.invest_score.profitability_score}`,
		`성장성 ${props.data.invest_score.potential_score}`,
		`밸류 ${props.data.invest_score.value_score}`,
		`배당 ${props.data.invest_score.allocation_score}`,
	];
	eventInvestmentIndicatorsValue.value = [
		props.data.invest_score.stability_score ?? 0,
		props.data.invest_score.profitability_score ?? 0,
		props.data.invest_score.potential_score ?? 0,
		props.data.invest_score.value_score ?? 0,
		props.data.invest_score.allocation_score ?? 0,
	];
	eventInvestmentIndicatorsDescription.value = [
		props.data.invest_score.stability_description ?? '',
		props.data.invest_score.profitability_description ?? '',
		props.data.invest_score.potential_description ?? '',
		props.data.invest_score.value_description ?? '',
		props.data.invest_score.allocation_description ?? '',
	];

	createChart();
});
</script>

<style scoped lang="scss">
.wrap_score {
	.section_chart {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.section_description {
		display: flex;
		flex-direction: column;
		gap: 3.2rem;
		.content_chartDetail {
			.chartDetail_btn {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 0.4rem;
				width: 100%;
				font-size: var(--font-s-regular);
				font-weight: var(--font-w-semi-bold);
				line-height: 2.1rem;
				padding: 1.35rem 0;
				border: 1px solid #818393;
				border-radius: 0.6rem;
				img {
					width: 1.6rem;
					height: 1.6rem;
				}
			}
			.chartDetail_description {
				margin-top: 2rem;
				.description_list {
					display: flex;
					flex-wrap: wrap;
					gap: 0.5rem;
					.list_box {
						display: flex;
						flex-direction: column;
						gap: 0.8rem;
						position: relative;
						width: calc(50% - 2.5px);
						background-color: #1b2433;
						padding: 2rem;
						border-radius: 0.8rem;
						.box_row_1 {
							display: flex;
							justify-content: space-between;
							align-items: center;
							overflow: hidden;
							.row_1_left {
								display: flex;
								align-items: center;
								gap: 0.4rem;
								font-size: var(--font-s-large);
								font-weight: var(--font-w-bold);
								line-height: 2.7rem;
								white-space: nowrap;
								p {
									color: #ffa800;
								}
							}
							.row_1_right {
								width: 2.4rem;
								height: 2.4rem;
								img {
									width: 2.4rem;
									height: 2.4rem;
								}
								cursor: pointer;
								.right_descriptionItem {
									display: flex;
									flex-direction: column;
									gap: 1rem;
									position: absolute;
									right: 0;
									z-index: 10;
									width: 31.2rem;
									background-color: #2c3646;
									padding: 1.6rem;
									font-size: var(--font-s-mid);
									font-weight: var(--font-w-light);
									line-height: 1.9rem;
									border-radius: 0.8rem;
									box-shadow: 4px 4px 10px 0px #0000004d;

									h4 {
										font-weight: var(--font-w-semi-bold);
									}
									ul {
										display: flex;
										flex-direction: column;
										gap: 1rem;
										li {
											display: flex;
											span:nth-child(1) {
												width: 120px;
												color: #ffa800;
											}
											span:nth-child(2) {
												width: 160px;
											}
										}
									}
									p {
										font-weight: var(--font-w-light);
										color: #c6c6d6;
									}
								}
								@media screen and (max-width: 1280px) {
									.leftItem {
										position: absolute;
										left: 0;
									}
								}
							}
						}
						.box_row_2 {
							font-size: var(--font-s-mid);
							font-weight: var(--font-w-light);
							line-height: 1.9rem;
							color: #c6c6d6;
						}
					}
				}
			}
		}
	}
}
.emptyData {
	text-align: center;
	// font-size: var(--font-s-regular);
	font-size: 1.6rem;
	font-weight: var(--font-w-light);
	line-height: 1.2;
}

.only_picked {
	display: flex;
	width: 100%;
	height: 258px;
	padding: 24px 0px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	align-self: stretch;
	p {
		color: var(--color-base-white, #fff);
		text-align: center;
		font-size: var(--font-s-regular);
		font-weight: 300;
		line-height: 2.3rem;
	}
}
</style>
